<template>
    <v-flex>
        <v-layout row wrap>
            <v-flex id="file-drag-drop">
                <div>
                    <form
                        ref="fileform"
                        v-on:drag.stop.prevent
                        v-on:dragstart.stop.prevent
                        v-on:dragend.stop.prevent
                        v-on:dragover.stop.prevent
                        v-on:dragenter.stop.prevent
                        v-on:dragleave.stop.prevent
                        v-on:drop.stop.prevent="onDropFiles"
                        class="drop-area">
                        <v-layout row wrap>
                            <v-flex xs8 v-if="files.length > 0">
                                <v-layout row class="drop-area__row">
                                    <v-flex v-for="(file,key, i) in files" :key="key" class="file-icons">

                                        <i large :class='iconClassNames(file.type)' class="icon-field">
                                                <em class="fa fa-minus-circle close-btn"
                                                    :data-qe-id="`file-${i}_remove_btn`"
                                                    @click="removeFile(key)"></em>
                                            </i>

                                        <span class="file-name" :title="file.name" :data-qe-id="`file-${i}_name`">
                                            {{file.name}}
                                        </span>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex v-if="!isFilesUploading" :class="[files.length > 0 ? xs4 : xs12]" class="file-select-btn">
                                <file-upload
                                    class="card__file-upload"
                                    v-model="addedFiles"
                                    ref="file_upload"
                                    :multiple="multiple"
                                    input-id="`file_upload_Id`"
                                    data-qe-id="`file_upload_Id`">
                                    <v-icon class="far fa-plus-square" large>
                                    </v-icon>
                                </file-upload>
                                <span class="drop-files">{{communityCommonConstant.filesAndMedia.BROWSE}}<br>{{communityCommonConstant.filesAndMedia.DRAG_FILES_HERE}}</span>
                            </v-flex>
                            <v-flex v-else xs4 class="upload-progress-area">
                                <v-icon class="fas fa-file-image icon-field" large>
                                </v-icon>
                                <v-icon class="fas fa-file-alt icon-field" large>
                                </v-icon>
                                <v-icon class="fas fa-file-medical icon-field" large>
                                </v-icon>
                                <progress class="progress" :value.prop="fileUploadPercentage" max="100">
                                </progress>
                                <span v-if="files.length < 6">{{fileUploadPercentage}}%</span>
                                <span v-else>{{communityCommonConstant.filesAndMedia.UPLOADING}} {{files.length}} {{communityCommonConstant.filesAndMedia.FILES}}</span>
                            </v-flex>
                        </v-layout>
                    </form>
                </div>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 sm7>
                <span class="error-message">{{errorMessage}}</span>
            </v-flex>
            <v-flex xs12 sm5 text-xs-right>
                <v-btn
                    id="file-upload_cancel_btn"
                    data-qe-id="file-upload_cancel_btn"
                    :disabled="isFilesUploading"
                    @click="closeFilesDialog()"
                    class="primary_btn small">
                    {{'Cancel'}}
                </v-btn>
                <v-btn
                    id="file-upload_add_btn"
                    data-qe-id="file-upload_add_btn"
                    :disabled="files.length === 0 || isFilesUploading"
                    @click="uploadFilesClick()"
                    class="primary_btn small">
                    {{'Add File'}}
                </v-btn>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
    import { mapActions, mapGetters } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { communityCommonConstant, iconClassNames } from "../ChapterPage/communityCommon.constant";
    import FileUpload from "vue-upload-component";
    import { fileAttachmentConsts } from '../ChapterPage/FileAttachment/FileAttachmentconstants';

    export default {
        data() {
            return {
                xs4: 'xs4',
                xs12: 'xs12',
                errorMessage: '',
                communityCommonConstant,
                addedFiles: [],
                multiple: true,
                files: [],
                isFilesUploading: false,
            };
        },
        props: {
            parentid: {
                type: String,
                default: null,
            },
            parentDirectory: {
                type: String,
                default: null,
            },
            existingFileNames: {
                type: Array,
                required: true,
            },
            fileTypesSupported: {
                type: Array,
                required: true,
            },
        },
        watch: {
            addedFiles(vals) {
                if (vals.length) {
                    vals.forEach((val) => {
                        if (this.validateFileType(val.file.name.toLowerCase()) && this.validateFileNameLength(val.file.name.split('.')[0]) && this.validateDuplicateName(val.file)) {
                            this.files.push(val.file);
                        }
                    });
                    this.addedFiles = [];
                }
            },
        },
        components: {
            FileUpload,
        },
        computed: {
            ...mapGetters("chapter", [storeGetters.fileUploadPercentage]),
        },
        methods: {
            ...mapActions({
                uploadFiles: `chapter/${storeAction.uploadFiles}`,
            }),
            onDropFiles(e) {
                const selectedFiles = e.dataTransfer.files;
                for (let i = 0; i < selectedFiles.length; i += 1) {
                    if (this.validateFileType(selectedFiles[i].name.toLowerCase()) && this.validateFileNameLength(selectedFiles[i].name.split('.')[0]) && this.validateDuplicateName(selectedFiles[i])) {
                        this.files.push(selectedFiles[i]);
                    }
                }
            },
            validateFileNameLength(filename) {
                if (filename.length > 40) {
                    this.errorMessage = communityCommonConstant.filesAndMedia.FILE_NAME_LENGTH_EXCEEDED;
                    setTimeout(() => { this.errorMessage = ''; }, communityCommonConstant.filesAndMedia.ERROR_MESSAGE_TIMEOUT_SECONDS);
                    return false;
                }
                return true;
            },
            validateFileType(filename) {
                if (!(new RegExp(this.fileTypesSupported.join("|")).test(filename))) {
                    this.errorMessage = communityCommonConstant.filesAndMedia.FILE_NOT_SUPPORTED;
                    setTimeout(() => { this.errorMessage = ''; }, communityCommonConstant.filesAndMedia.ERROR_MESSAGE_TIMEOUT_SECONDS);
                    return false;
                }
                return true;
            },
            validateDuplicateName(file) {
                let isValid = true;
                if (this.files.filter(f => f.name === file.name).length > 0 || this.existingFileNames.filter(name => name === file.name).length > 0) {
                    this.errorMessage = file.isFolder ? communityCommonConstant.filesAndMedia.FOlDERNAME_ALREADY_EXISTS : communityCommonConstant.filesAndMedia.FILENAME_ALREADY_EXISTS;
                    setTimeout(() => { this.errorMessage = ''; }, communityCommonConstant.filesAndMedia.ERROR_MESSAGE_TIMEOUT_SECONDS);
                    isValid = false;
                }
                return isValid;
            },
            removeFile(key) {
                this.files.splice(key, 1);
            },
            iconClassNames,
            uploadFilesClick() {
                if (this.files.length > 0) {
                    const MAX_FILE_SIZE_BYTES = fileAttachmentConsts.MAX_FILE_SIZE * 1024 * 1024;
                    const largeFile = this.files.find(file => file.size > MAX_FILE_SIZE_BYTES);

                    if (largeFile) {
                        this.errorMessage = fileAttachmentConsts.FILE_SIZE_EXCEEDED_DRAG_DROP;
                        setTimeout(() => { this.errorMessage = ''; }, communityCommonConstant.filesAndMedia.ERROR_MESSAGE_TIMEOUT_SECONDS);
                        this.files = [];
                        return;
                    }

                    this.isFilesUploading = true;
                    const formData = new FormData();
                    this.files.forEach((file, i) => {
                        formData.append(`Files[${i}]`, file);
                    });
                    formData.append('ParentId', this.parentid);
                    formData.append('ParentDirectory', this.parentDirectory);

                    this.uploadFiles(formData)
                        .then(() => {
                            this.isFilesUploading = false;
                            this.files = [];
                            this.closeFilesDialog();
                        })
                        .catch((err) => {
                            this.isFilesUploading = false;
                            if (err.response && err.response.data && err.response.data.message) {
                                this.errorMessage = err.response.data.message;
                            } else {
                                this.errorMessage = communityCommonConstant.filesAndMedia.ERROR_WHILE_UPLOADING;
                            }
                            setTimeout(() => { this.errorMessage = ''; }, communityCommonConstant.filesAndMedia.ERROR_MESSAGE_TIMEOUT_SECONDS);
                        });
                }
            },

            closeFilesDialog() {
                this.$emit('closeDialog');
            },
        },
    };
</script>

<style lang="scss">
    @import "../../common/styles/_colors.scss";
    @import '../../common/styles/_responsive.scss';
    $control-height: 100px;
    $marginTop-progress: $control-height - 85px;
    $dragdrop_background: $ypo-extra-light-gray;
    $dragdrop_background_mian: $white;
    $dorder_dash_color: $ypo-light-medium-gray;
    $image_icon_color:$ypo-duskblue;

    #file-drag-drop {
        background-color: $dragdrop_background;

        .drop-area {
            border: 2px dashed $dorder_dash_color;
            border-radius: 4px;
            background-color: $dragdrop_background_mian;
            padding: 20px;
            margin: 10px 10px 30px 10px;
            text-align: center;

            &__row {
                max-width: 100%;
                overflow-x: auto;
            }
        }

        .file-icons {
            padding: 5px 0;
            margin: 0 15px;
            max-width: 80px;

            i {
                font-size: 40px;
                color: $image_icon_color;
                position: relative;
            }

            em {
                position: absolute;
                top: -5px;
                right: -23px;
                font-size: 18px;
                cursor: pointer;
                color: $image_icon_color;
            }

            span {
                color: $image_icon_color !important;
                margin-top: 5px;
                display: block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .file-select-btn {
            color: $ypo-duskblue;

            .icon-field {
                color: $ypo-duskblue;
            }

            span {
                color: $ypo-duskblue;
                display: block;

                i {
                    color: $ypo-duskblue;
                }

                label {
                    cursor: pointer;
                }
            }
        }

        .upload-progress-area {
            .icon-field {
                margin-left: -5px;
                color: $ypo-duskblue
            }

            span {
                color: $ypo-duskblue;
            }
        @include breakpoint(xs) {
            overflow-x: auto;
            .icon-field {
                font-size: 26px !important;
                margin-left: 4px;
            }
        }    
        }

        .progress {
            appearance: none;
            padding: 0;
            border: none;
            border-radius: 0;
            display: block;
            color: $ypo-duskblue;
            width: 250px;
            height: 5px;
            margin-top: $marginTop-progress;
        }

        /* Chrome */
        progress::-webkit-progress-bar {
            background-color: $ypo-light-gray;
        }

        progress::-moz-progress-bar {
            background-color: $ypo-light-gray;
        }

        progress::-webkit-progress-value {
            background-color: $ypo-duskblue;
        }
    }

    .error-message {
        color: red;
        margin: 8px;
    }
</style>
